<div class="content">
    <h2>Erzeugungsanlagen</h2>

    <tnb-erzeugungsanlage-list></tnb-erzeugungsanlage-list>
</div>

